export default function TargetFirmwareVersionsResponse(e) {
  var p = {};
  if (e) {
    p = {
      id: e.id,
      externalId: e.externalId,
      manufacturerId: e.manufacturerId,
      transmitterMountingTypeId: e.transmitterMountingTypeId,
      hardwareVersion: e.hardwareVersion,
      firmwareVersion: e.firmwareVersion + " " + "[" + e.externalId + "]",
      source: e.source,
      createdUser: e.createdUser,
      createdDate: e.createdDate,
      updatedUser: e.updatedUser,
      updatedDate: e.updatedDate,
    };
  }
  return p;
}
